module.exports = __webpack_public_path__ + "img/title.5c2fc8d1.png";